import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import { autorun } from 'mobx';
import store from 'store';

import { useServiceRouter } from '@common/components/ServiceRouter';
import { useToggle } from '@common/helpers/useToggle';

import BellRingButton from './BellRing';
import BurgerMenu from './BurgerMenu';
import LangMenu from './LangMenu';
import LogoSection from './LogoSection';
import MessagesIcon from './MessagesIcon';
import NotificationModal from './NotificationModal';
import { HeaderLanguage, Right, Toolbar } from './styled';

function HeaderToolBar() {
	const notificationModalControls = useToggle();
	const { checkService } = useServiceRouter();
	const isTalented = checkService('talented');

	useEffect(() => {
		const dispose = autorun(() => {
			if (store.modalNotifications.data.length) {
				notificationModalControls.onOpen({ notification: store.modalNotifications.data[0] });
			}
		});

		return () => dispose();
	}, []);

	return (
		<Toolbar>
			<LogoSection />

			<Right>
				{!store.profile.viewOnlyMode && !(isTalented && !store.profile.consultation) && (
					<MessagesIcon />
				)}
				<BellRingButton />
				<HeaderLanguage>
					<LangMenu />
				</HeaderLanguage>
				<BurgerMenu />
				{notificationModalControls.isOpen ? (
					<NotificationModal controls={notificationModalControls} />
				) : null}
			</Right>
		</Toolbar>
	);
}

export default observer(HeaderToolBar);
